import React from 'react'

function HeaderWithButton({ title, description, buttonText, onButtonClick, showButton }) {
  return (
    // <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-start sm:items-center mt-6">
    //   <div>
    //     <h1 className="text-base font-semibold leading-6 text-gray-900">
    //       {title}
    //     </h1>
    //     <p className="mt-2 text-sm text-gray-700">{`A list of all ${description} report `}</p>
    //   </div>
    //   <div className="sm:justify-self-end">
    //     <button
    //       type="button"
    //       className="block w-full sm:w-auto rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
    //       onClick={onButtonClick}
    //     >
    //       {`Add ${buttonText}`}
    //     </button>
    //   </div>
    // </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-start sm:items-center mt-6">
    <div>
      <h1 className="text-base font-semibold leading-6 text-gray-900">
        {title}
      </h1>
      <p className="mt-2 text-sm text-gray-700">{`A list of all ${description} report`}</p>
    </div>
    {showButton && ( // Only show button if showButton is true
      <div className="sm:justify-self-end">
        <button
          type="button"
          className="block w-full sm:w-auto rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={onButtonClick}
        >
          {`Add ${buttonText}`}
        </button>
      </div>
    )}
  </div>
  )
}

export default HeaderWithButton